// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://gesmjeokchbtbxthrizm.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imdlc21qZW9rY2hidGJ4dGhyaXptIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTQzMTQ5NTQsImV4cCI6MjA2OTg5MDk1NH0.xYWYZNj6MS7ViA3Su8mw9tJYGDvy5IXdOGr5fXywd7E";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});